(function (window, document, API_URL, JSONP_COUNTER, undefined) {

// https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
if (typeof Object.assign != 'function') {
	Object.assign = function(target, varArgs) { // .length of function is 2
		'use strict';
		if (target == null) { // TypeError if undefined or null
			throw new TypeError('Cannot convert undefined or null to object');
		}

		var to = Object(target);

		for (var index = 1; index < arguments.length; index++) {
			var nextSource = arguments[index];

			if (nextSource != null) { // Skip over if undefined or null
				for (var nextKey in nextSource) {
					// Avoid bugs when hasOwnProperty is shadowed
					if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
						to[nextKey] = nextSource[nextKey];
					}
				}
			}
		}
		return to;
	};
}

function supportsBeacon() {
	var ua = navigator.userAgent || navigator.vendor || window.opera;
	var fbBrowser = ua.indexOf("FBAN") > -1 || ua.indexOf("FBAV") > -1;
	
	return navigator.sendBeacon && !fbBrowser;
}

function beacon(url, params) {
	var isSent = false;
	
    if (supportsBeacon()) {
		var data = serialize(params);
		
		try {
			isSent = navigator.sendBeacon(url, data);
		} catch (err) {
			if (window.lr && lr.api) {
				lr.api.registerError("abc zeta: " + err, null, { url: url, data: data });
			} else {
				throw err;
			}
		}
    }

	if (!isSent) {
		jsonp(url, { data: params });
	}
}

var metaContent = null;

function getPageMetadata() {
	if (metaContent)
		return metaContent;

	metaContent = {};

	var metaTags = document.getElementsByTagName("meta");

	for (var i = 0; i < metaTags.length; i++) {
		var name = (metaTags[i].getAttribute("name") || metaTags[i].getAttribute("property") || "").toLowerCase();

		if (!name)
			continue;

		if (metaContent[name]) {
			metaContent[name].push(metaTags[i].getAttribute("content"));
		} else
			metaContent[name] = [metaTags[i].getAttribute("content")];
	}

	return metaContent;
}

function getMeta(name, index) {
	if (!index)
		index = 0;
	var data = getPageMetadata();
	if (data[name] && data[name].length > index)
		return data[name][index];
	return null;
}
function getScrollPosition() {
	return window.pageYOffset && (document.documentElement && document.documentElement.scrollTop) || (document.body && document.body.scrollTop);
}
function makeUrl(url, params) {
	var queryString = serialize(params);
	return url + (!!queryString ?  (url.indexOf('?') === -1 ? '?' : '&') + queryString : '');
}

function include(url, params, onload) {
	var script = document.createElement("script");
	script.setAttribute("src", makeUrl(url, params));
	script.async = true;

	if (onload !== undefined) {
		if (script.onreadystatechange !== undefined) {
			script.onreadystatechange = function () {
				if (this.readyState === "complete" || this.readyState === "loaded") {
					onload();
				}
			};
		} else {
			script.onload = onload;
		}
	}

	var s = document.getElementsByTagName('script')[0];
	s.parentNode.insertBefore(script, s);

	return script;
}

window[JSONP_COUNTER] = ~~window[JSONP_COUNTER];

function jsonp(url, settings, callback) {
	var callbackFunction = '__jsonp_callback_' + (++window[JSONP_COUNTER]),
		timer = 0;

	settings = settings || {};

	window[callbackFunction] = function () {
		if (typeof (callback) === "function") {
			callback.apply(callback, arguments);
		}

		if (timer) {
			clearTimeout(timer);
		}

		try {
			delete window[callbackFunction];
		} catch(e) {
			window[callbackFunction] = undefined;
		}
	};

	url = url + (url.indexOf('?') === -1 ? '?' : '&') + (settings.jsonpCallback || "callback") + '=' + callbackFunction;

	var script = include(url, settings.data || {});

	if (settings.timeout) {
		timer = setTimeout(function () {
			script.parentNode.removeChild(script);
			window[callbackFunction](null);
		}, settings.timeout);
	}
}

function inPrivate() {
	var result = false;

	if (window.localStorage && /Safari/.test(window.navigator.userAgent)) {
		try { localStorage.abctest = 2; } catch (e) {
			result = true;
		}
	}

	return result;
}
function serialize(obj) {
	var result = [],
		buildParams = function (key, value) {
			if (value === undefined || value === null)
				return;

			if (Object.prototype.toString.call(value) === "[object Date]") {
				result.push((!!key ? encodeURIComponent(key) + "=" + value.toISOString() : value));
			} else if (Object.prototype.toString.call(value) === "[object Array]") {
				for (var i = 0; i < value.length; i++) {
					buildParams(!!key ? key + "[" + i + "]" : "", value[i]);
				}
			} else if (typeof(value) === "object") {
				for (var field in value) {
					if (!value.hasOwnProperty(field))
						continue;

					buildParams(!!key ? key + "." + field : field, value[field]);
				}
			} else {
				value = typeof(value) === "function" ? value() : value;
				result.push((!!key ? encodeURIComponent(key) + "=" + encodeURIComponent(value) : value));
			}
		};

	buildParams("", obj);

	return result.join("&").replace(/%20/g, "+");
}
var pageUrl = null;
var canonicalUrl = null;

function getPageUrl() {
	if (pageUrl !== null)
		return pageUrl;

	pageUrl = document.location.href;

	if (inPrivate())
		pageUrl = makeUrl(pageUrl, { utm_p: 1 });

	return pageUrl;
}

function getCanonicalUrl() {
	if (canonicalUrl !== null)
		return canonicalUrl;

	var links = document.getElementsByTagName("link");

	for (var i = 0; i < links.length; i++) {
		if (links[i].getAttribute("rel") === "canonical")
			return (canonicalUrl = links[i].getAttribute("href"));
	}

	return (canonicalUrl = getMeta('og:url') || "");
}

var maxScrollPosition = getScrollPosition();

setInterval(function () {
	var currentScrollPosition = getScrollPosition();

	maxScrollPosition = currentScrollPosition > maxScrollPosition ? currentScrollPosition : maxScrollPosition;
}, 500);
var siteUid;
var siteParams = {};
var zetaUrl = API_URL;

var apiMethods = {
	"set": function (parameter, value) {
		switch (parameter) {
			case "siteUid":
				siteUid = value;
				break;

			case "zetaUrl":
				zetaUrl = value;
				break;

			default:
				siteParams[parameter] = value;
				break;
		}
	},

	"send": function (category, action, label, url, customParams) {
		beacon(zetaUrl, Object.assign({}, siteParams, customParams, {
			suid: siteUid,

			u: getPageUrl(),
			c: url || getCanonicalUrl(),

			o: category,
			n: action,
            a: label,
            z_pt: customParams.placement,
            z_c: customParams.section,

			r: (document.referrer && document.referrer.length > 200 ? document.referrer.substring(0, 200) + "[cut]" : document.referrer),
			l: navigator.language || navigator.browserLanguage || navigator.userLanguage,
			tz: (new Date()).getTimezoneOffset(),
			s: maxScrollPosition,
			sw: screen.width,
			sh: screen.height,
			cw: document.body && document.body.clientWidth,
			ch: document.body && document.body.clientHeight || "",

			pl: customParams.pl,

			f: 1
		}));
	}
};


var zetaQueueName = window._zeta_queue_ || 'zeta';
(function (publicApi, slice) {
	var queue = publicApi.q || [];
	for (var i = 0; i < queue.length; i++) {
		var args = queue[i];
		if (!!args && args.length && args[0] in apiMethods) {
			apiMethods[args[0]].apply(apiMethods, slice.call(args, 1));
		}
	}

	if (!publicApi.loaded) {
		publicApi = window[zetaQueueName] = function (action) {
			if (action in apiMethods) {
				apiMethods[action].apply(apiMethods, slice.call(arguments, 1));
			}
		};

		publicApi.loaded = true;
	}
})(window[zetaQueueName] || {}, Array.prototype.slice);

})(window, document,"//zeta.quizzclub.com/12e8","__jsonp_callback_counter");
